import { API_URL, logger } from "Constants";
import axios, { AxiosInstance } from "axios";

export const http: AxiosInstance = axios.create({
  baseURL: API_URL,
});

http.interceptors.request.use(
  (config) => {
    // const token = localStorageService.getAccessToken()
    // if (token) {
    //   config.headers['Authorization'] = 'Bearer ' + token
    // }
    // config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => Promise.reject(error)
);

http.interceptors.response.use(
  (res) => {
    // logger.log(res);
    if (res.data.status >= 400) {
      throw new Error(res.data.message);
    }
    return res;
  },
  (err) => {
    logger.error(err);
    return Promise.reject(err);
  }
);

export default http;
